import React, { createContext, Dispatch, useContext, useReducer } from "react";

type ForgotPasswordContextType = {
  state: ForgotPasswordProviderState;
  dispatch: Dispatch<ForgotPasswordProviderState>;
};

export const ForgotPasswordContext =
  createContext<ForgotPasswordContextType | null>(null);

type ForgotPasswordProviderState = {
  isLoading?: boolean;
  emailError?: string;
  email?: string;
};

const forgotPasswordReducer = (
  state: ForgotPasswordProviderState,
  newState: ForgotPasswordProviderState,
): ForgotPasswordProviderState => {
  return {
    email: newState.email ?? state.email,
    emailError: newState.emailError ?? state.emailError,
    isLoading: newState.isLoading ?? state.isLoading,
  };
};

const initialState: ForgotPasswordProviderState = {
  isLoading: false,
  emailError: "",
  email: null,
};

export const ForgotPasswordProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [state, dispatch] = useReducer(forgotPasswordReducer, initialState);

  return (
    <ForgotPasswordContext.Provider value={{ state, dispatch }}>
      {children}
    </ForgotPasswordContext.Provider>
  );
};

export const useForgotPasswordContext = () => {
  const context = useContext(ForgotPasswordContext);

  if (!context) {
    throw new Error(
      "useForgotPasswordContext must be used within ForgotPasswordProvider",
    );
  }

  return context;
};
